'use client';

import React, { useEffect, useRef } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function TradingViewChart() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useLanguage();

  useEffect(() => {
    if (!containerRef?.current) return;

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: false,
      width: '100%',
      height: 700,
      symbol: 'OANDA:XAUUSD',
      interval: '15',
      timezone: 'Etc/UTC',
      theme: 'dark',
      style: '1',
      locale: 'en',
      backgroundColor: '#09090f',
      gridColor: 'rgba(255,255,255,0.04)',
      hide_top_toolbar: false,
      hide_legend: false,
      save_image: false,
      calendar: false,
      hide_volume: false,
      support_host: 'https://www.tradingview.com',
    });

    containerRef?.current?.appendChild(script);

    return () => {
      if (containerRef?.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="w-full rounded-xl border border-white/10 bg-[#0e0e17] overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-[#d4af37] animate-pulse" />
          <span className="text-sm font-semibold text-zinc-200 tracking-wide">{t('liveChart')}</span>
          <span className="text-xs text-zinc-500 font-mono ml-1">M15</span>
        </div>
        <span className="text-xs text-zinc-600 font-mono">TradingView</span>
      </div>

      {/* Responsive height wrapper: 350px mobile, 450px sm, 550px md, 700px lg */}
      <div className="h-[350px] sm:h-[450px] md:h-[550px] lg:h-[700px] w-full">
        <div
          className="tradingview-widget-container h-full w-full"
          ref={containerRef}
        >
          <div className="tradingview-widget-container__widget h-full w-full" />
        </div>
      </div>
    </div>
  );
}
